import { createApp } from 'vue'
import { MotionPlugin } from '@vueuse/motion'
import 'preline/preline'
import App from './App.vue'
import router from './router'
import './style.css'

createApp(App).use(router).use(MotionPlugin).mount('#app')
